<template>
  <base-section id="theme-features">
    <base-section-heading title="Frequently Asked Questions" />
    <v-container>
      <v-card>
        <v-expansion-panels>
          <v-expansion-panel v-for="(item, i) in questions" :key="i">
            <v-expansion-panel-header>{{
              item.title
            }}</v-expansion-panel-header>
            <v-expansion-panel-content>{{
              item.content
            }}</v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card>
    </v-container>
  </base-section>
</template>

<script>
export default {
  name: "FaqSection",

  data: () => ({
    questions: [
      {
        title: "What service do you offer?",
        content:
          "We offer loans to BPO employees who are able to pay back at the agreed time",
      },
      {
        title: "Who can apply for a loan?",
        content: `To apply for a loan with us, interested clients must be over 18 years or older, be actively employed in the BPO sector for more than 3 months.`,
      },
      {
        title: "BPO industry Requirements",
        content: `(3) Months bank statement for salaried account, Valid ID, TRN, Social Verification, (3) Months’ Pay Slip for each pay period, Proof of Address.`,
      },
      {
        title: "Do you offer term loans?",
        content: `Yes, we do.`,
      },
      {
        title: "How do I qualify for a term loan?",
        content: `Term loans are applicable to BPO Management or BPO Agents with six or more non-delinquent payday transactions or through salary deduction.`,
      },
      {
        title: "What is the maximum loan amount I can apply for?",
        content: ` BPO Agents- maximum on payday is $30,000 and maximum approval for BPO management on payday is $50,000. BPO Management on salary deduction for term loans can get up to $100,000 and Agents on salary deduction for term loans may get up to - $70,000. `,
      },
      {
        title: "What banks do you accept?",
        content: "All local banks that allow transfer to NCB",
      },
      {
        title: "How quick can I get a loan",
        content: "Average time for new client’s approval time is 24-48 hours",
      },
      {
        title: "What are your operation hours?",
        content: "Monday to Friday 9AM- 6PM, Saturday 9AM- 2PM, Sunday (Closed)",
      },
      {
        title: "What type of cards can I use to payback my loan?",
        content:
          "You may use a visa or MasterCard debit from any bank.",
      },
      {
        title: "What is the maximum loan amount I can apply for?",
        content: `Payday Maximum for agents $30,000, Payday Maximum for Management $50,000, Term Maximum for agents $70,000, Term Maximum for agents $100,000`,
      },
      {
        title: "How can I increase my loan amount?",
        content: "After six (6) successful transactions without a delinquent status your maximum is raised to a higher amount providing that your salary can facilitate the new approval.",
      },
      {
        title: "Can I pay back part of my loan or only the interest?",
        content:
          `Loans should be settled in full or under negotiated terms`,
      },
      {
        title: "How soon can I refinance?",
        content: "We offer same day refinance. Once your loan is paid back under the terms and condition of your loan agreement",
      },
      {
        title: "How soon can I refinance?",
        content: `We offer same day refinance. Once your loan is paid back under the terms and condition of your loan agreement.`,
      },
      {
        title: "Why pay back in full?",
        content: `Paying back in full is a sure indicator that the loan you have requested is within your financial reach and increases your chance of becoming an Orenda premium client.`,
      },
      {
        title: "What is Social verification?",
        content: `This is personal identification through any of the major social media outlets such as Instagram and Facebook. To complete this process clients should follow Orenda on either platform and accept the follow back request from Orenda.`,
      },
      {
        title: "What is a Roll over?",
        content: `This is a fee of $2,000.00 which allows clients to pay on their next payday when the client has communicated on or before their due date.`,
      },
      {
        title: "How often can apply roll over?",
        content: `Once per month `,
      },
      
    ],
  }),
};
</script>
